module.exports = {
      id: "authorwhite-usage",
      viewBox: "0 0 30.127 24.506",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#authorwhite",
      toString: function () {
        return this.url;
      }
    }